var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-options"},_vm._l((_vm.optionsResponse.providers),function(provider,i){return _c('paymentprovider',{key:i,attrs:{"provider":provider}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }